import { PluginType, type IExportPlugin } from '@/version-types';
import { TextLayerSVGPreviewPlugin } from './manager';
import { TextLayerSVGPreview } from './view';

export const textLayerSVGPreviewPlugin: IExportPlugin = {
    sort: 10,
    type: PluginType.STAGE,
    name: 'text-layer-svg-preview',
    render: () => <TextLayerSVGPreview />,
    createInstance: ({ identity }) => [
        { key: 'TextLayerSVGPreviewPlugin', value: new TextLayerSVGPreviewPlugin(identity) },
    ],
    destroy: ({ getInstance }) => getInstance<TextLayerSVGPreviewPlugin>('TextLayerSVGPreviewPlugin').dispose(),
};
